import moment from 'moment-timezone';

/**
 * What `companies.time_zone` defaults to in the database, and therefore the answer for a browser this cannot
 * place. The alphabetically first US zone is `America/Adak` — three hundred people on an island in the
 * Aleutians — and a company quietly filed there keeps its scheduled messages nine hours from where they
 * belong.
 */
const FALLBACK_TIMEZONE = 'America/New_York';

/**
 * The zone a company should start on: the browser's, when the product can offer it. Only US zones are on
 * offer anywhere the value is later edited, so a browser reporting anything else is not placed at all.
 */
export function getCompanyTimezone() {
  const guessed = moment.tz.guess();
  return moment.tz.zonesForCountry('US').includes(guessed) ? guessed : FALLBACK_TIMEZONE;
}
